import { Box } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import Image from "next/image";

interface ImagePreviewProps {
  alt: string;
  src: string;
}

export const ImagePreviewModalContext = {
  modal: "imagePreview",
  innerProps: {},
};

export const ImagePreview = ({ innerProps }: ContextModalProps<ImagePreviewProps>) => {
  return (
    <Box pos="relative">
      <Image width={500} height={500} layout="responsive" alt={innerProps.alt} src={innerProps.src} />
    </Box>
  );
};
